import { statusOf, TYRE_STATES } from './diagramTheme';

const kilometers = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 });

export const describePosition = (position) => {
  const fitment = position.current_fitment;
  const description = `${position.label} · ${TYRE_STATES[statusOf(position)].label}`;
  if (!fitment) return description;

  const total = fitment.total_km;
  const distance = typeof total === 'number' && Number.isFinite(total)
    ? `${kilometers.format(total)} km`
    : 'Unavailable';
  return `${description} · Total kilometers: ${distance}`;
};
